import type { CountryConfig } from "@orvis/core";
import { ADMOB_NI } from "../ads.js";
import { defaultDarkTheme } from "../theme.js";

/**
 * Nicaragua config.
 *   - Firestore collection: `ni`
 *   - Play Store id:       com.mlopezitsolutions.nictv (legacy listing, last
 *     shipped versionCode 11 in 2018 — no source survives in legacy/)
 *   - News feeds: aggregated server-side by `updateNews` into `ni/news`,
 *     same as CR. La Prensa (laprensani.com) and Artículo 66 sit behind a
 *     Cloudflare challenge and El Nuevo Diario is offline (checked
 *     2026-10), so they're left out.
 */
export const ni: CountryConfig = {
  code: "ni",
  name: "Nicaragua",
  flag: "🇳🇮",
  defaultLocale: "es",
  bundleId: "com.mlopezitsolutions.nictv",
  newsSources: [
    {
      id: "confidencial",
      name: "Confidencial",
      feedUrl: "https://www.confidencial.digital/feed/",
      kind: "rss",
      language: "es",
      homepage: "https://www.confidencial.digital/",
      enabled: true,
      category: "general",
    },
    {
      id: "despacho505",
      name: "Despacho 505",
      feedUrl: "https://www.despacho505.com/feed/",
      kind: "rss",
      language: "es",
      homepage: "https://www.despacho505.com/",
      enabled: true,
      category: "general",
    },
    {
      id: "nicaragua-investiga",
      name: "Nicaragua Investiga",
      feedUrl: "https://www.nicaraguainvestiga.com/feed/",
      kind: "rss",
      language: "es",
      homepage: "https://www.nicaraguainvestiga.com/",
      enabled: true,
      category: "general",
    },
    {
      id: "divergentes",
      name: "Divergentes",
      feedUrl: "https://www.divergentes.com/feed/",
      kind: "rss",
      language: "es",
      homepage: "https://www.divergentes.com/",
      enabled: true,
      category: "general",
    },
  ],
  ads: {
    publisherId: ADMOB_NI.publisherId,
    bannerUnitId: ADMOB_NI.banner,
    interstitialUnitId: ADMOB_NI.interstitialPlayChannel,
    appOpenUnitId: ADMOB_NI.appOpen,
  },
  theme: defaultDarkTheme,
};
